import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '../../ui/button/button';
import { Checkbox } from '../../ui/input/checkbox';
import { Table } from '../../ui/table/table';
import { PathParams, RoutingPath } from '../../../routes/routing-path';
import { push } from 'connected-react-router';
import { DisplayElement } from '../../../models/display-element';
import iconDelete from '../../../assets/img/icon/delete.svg';
import iconInfo from '../../../assets/img/icon/info_black_24dp.svg';
import { dialogActions } from '../../dialog/slice/dialog-slice';
import { DetailSearch } from '../../dialog/unique/detail-search';
import { apiActions } from '../../../slices/api-slice';
import { ResponseBase } from '../../../api/response-base';
import { commonActions } from '../../../slices/common-slice';
import { orderPreparationActions } from '../../../slices/order-preparation-slice';
import { ApiNumberingOrder } from '../../../api/back/numbering-order/api-numbering-order';
import { NumberingOrderResponse } from '../../../models/api/back/numbering-order';
import { useParams } from 'react-router-dom';
import { ApiOrders } from '../../../api/back/orders/api-orders';
import { OrdersResponse } from '../../../models/api/back/orders';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import lodash from 'lodash';
import { newsListActions } from '../../../slices/news-list-slice';
import { LoadingBar } from '../../ui/loading/loading-bar';
import { Input } from '../../ui/input/input';
import padlockOnIcon from '../../../assets/img/icon/padlock_on_icon.svg';
import {
  ApiShopOrderListGet,
  ShopOrderListGetResponseStatus,
} from '../../../api/front/shop-order/api-shop-order-list';
import { DateFormatter } from '../../../utilities/date-formatter';
import { LoadingPopup } from '../../ui/loading/loading-popup';
import { OrderLockCheckResponse } from '../../../api/front/lock-order/api-lock-orders';
import { localStorageActions } from '../../../slices/local-storage-slice';
import { ColorIcon } from '../../ui/color-icon/color-icon';
import warningIcon from '../../../assets/img/icon/warning_icon.svg';
import { LaboOrderCompChecker } from '../../../utilities/labo-order-comp-checker';
import { ApiGetStaffNameList } from '../../../api/front/staff/api-staff-name';
import { GetStaffNameResponse, StaffNameEntity } from '../../../models/api/front/staff-management';
import { Header } from '../../ui/header/header';
import { ApiPrintShopOrderStatusListGet, PrintStatusList } from '../../../api/sift/front/api-print-shop-order-list';
import { ApiPrintMetaShopOrderGet, ApiPrintMetaShopOrderPost, MetaPrintShopOrderGetResponse } from '../../../api/sift/front/api-print-meta-shop-order';
import { printActions } from '../../../slices/sift/print-slice';
import { usePrintLock } from '../sift/hooks/use-print-lock';
import { ApiPrintOrderLockCheck } from '../../../api/front/lock-order/api-lock-orders.print';
import { printOrderLockActions } from '../../../slices/lock-order-slice.print';
import { FaShuffle } from "react-icons/fa6";
import iconChangeTable from '../../../assets/img/icon/icon_change_table.jpg';
import { ApiPrintShopOrderCopy } from '../../../api/sift/front/api-print-shop-order-copy';
import { LabOrderForPrint } from '../../dialog/unique/lab-order-for-print';
import './print.scss';
import { ApiPrintShopOrderDataDelete } from '../../../api/sift/front/api-print-meta-shop-order-data';
import {formatShortDate} from "../order-list/order-table";

// - 検索条件 -
// -- 検索条件種類 --
type SearchType
  = 'all'
  | 'creating'
  | 'created'
  | 'layout'
  | 'enabledOrder'
  | 'ordering'
  | 'ordered'
  | 'othersOrdered';
// -- 注文ステータスコード --
type OrderStatusCode = '0' | '1' | '2' | '3' | '4' | '5' | '6';
// -- 検索条件ボタンデータ --
const searchButtonList: {
  type: SearchType,
  label: string,
  value: string,
  code: OrderStatusCode,
}[] = [
    {
      type: 'all',
      label: 'すべて',
      value: 'すべて',
      code: '0',
    },
    {
      type: 'creating',
      label: '注文作成中',
      value: '注文作成中',
      code: '1',
    },
    {
      type: 'created',
      label: '注文作成済み',
      value: '注文作成済',
      code: '2',
    },
    {
      type: 'layout',
      label: 'レイアウト中',
      value: 'レイアウト中',
      code: '3',
    },
    {
      type: 'enabledOrder',
      label: '発注可',
      value: 'ラボ発注可',
      code: '4',
    },
    {
      type: 'ordering',
      label: '発注中',
      value: 'ラボ発注中',
      code: '5',
    },
    {
      type: 'ordered',
      label: '発注完了',
      value: 'ラボ発注完了',
      code: '6',
    },
    {
      type: 'othersOrdered',
      label: '発注済み以外',
      value: '発注済み以外',
      code: '0',
    },
  ];

type SelectButtonProps = {
  // - ボタン種類 -
  type: SearchType,
  // - 選択中のボタンの種類 -
  currentType: SearchType,
  // - 表示する文言 -
  label: string,
  // - ボタン押下時のハンドラ -
  callback: (v: SearchType) => void,
};

type TableData = {
  createDate: string,
  lastName: string | null,
  lastUpdateDate: string,
  lockUser: string | null,
  note: string | null,
  orderDate: string | null,
  shopOrderId: string,
  status: string,
  orderCompleteDate: string,
  orderUser: string,
  prodManagNo: string,
  centerShippinDate?: string,
};

type StatusData = {
  shopOrderId: string,
  orderStatusName: string,
  orderStatus: string,
  ppmOrderStatus: string,
};

export type SearchParam = {
  // 作成日
  // 更新日
  date: { from: string, to: string },
  // 注文番号
  orderId: string,
  // お客様名
  customerName: string,
  // 作成日/更新日
  dateType: 'create' | 'update',
};

// - 検索条件選択ボタン用コンポネント -
const SelectButton = (props: SelectButtonProps) => {
  const { type, currentType, label, callback } = props;
  return (
    <div
      onClick={() => callback(type)}
      className={`type_select_button ${type === currentType ? 'current' : ''}`}
    >
      {label}
    </div>
  );
};

// 遷移先指定
const moveOrderDetailProp = () => {
  return RoutingPath.cnv.oneStopOrdersPreparation
}

// ステータス絞り込み
const orderedStatusFilter = (
  res: TableData[],
  orderedList: StatusData[],
  searchType: SearchType,
  searchParam: SearchParam,
) => {
  const key = () => {
    switch (searchType) {
      case 'all':
        return 'すべて';
      case 'creating':
        return '注文作成中';
      case 'created':
        return '注文作成済';
      case 'enabledOrder':
        return 'ラボ発注可';
      case 'layout':
        return 'レイアウト中';
      case 'ordering':
        return 'ラボ発注中';
      case 'ordered':
        return 'ラボ発注完了';
      default:
        return '';
    }
  };
  const checkCfStatus = (data: TableData) => {
    return data.status === 'ラボ発注中' && data.orderDate;
  }
  if (searchType === 'ordered') {
    return orderSearchFilter(res.filter((v) => (v.status !== '注文作成中' && v.status !== '注文作成済' && v.status !== 'レイアウト中' && v.status !== 'ラボ発注可' && v.status !== 'ラボ発注中') || orderedList.find((o) => o.shopOrderId === v.shopOrderId)), searchParam);
  } else if (searchType === 'ordering') {
    return orderSearchFilter(res.filter((v) => v.status === 'ラボ発注中' && !checkCfStatus(v)), searchParam);
  } else if (searchType !== 'all' && searchType !== 'othersOrdered') {
    return orderSearchFilter(res.filter((v) => v.status === key()), searchParam);
  } else if (searchType === 'othersOrdered') {
    return orderSearchFilter(res.filter((v) => !(v.status !== '注文作成中' && v.status !== '注文作成済' && v.status !== 'レイアウト中' && v.status !== 'ラボ発注可' && v.status !== 'ラボ発注中') && !orderedList.find((o) => o.shopOrderId === v.shopOrderId)), searchParam);
  } else {
    return orderSearchFilter(res, searchParam);
  }
};
// 詳細検索絞り込み
const orderSearchFilter = (
  res: TableData[],
  search: SearchParam,
) => {
  const fromDate = (search.date.from !== '') ? (res.filter((v) =>
    (search.dateType === 'create') ? Date.parse(v.createDate) >= Date.parse(search.date.from) - 32400000 : Date.parse(v.lastUpdateDate) >= Date.parse(search.date.from) - 32400000)) : [...res];
  const toDate = (search.date.to !== '') ? (fromDate.filter((v) =>
    (search.dateType === 'create') ? Date.parse(v.createDate) < Date.parse(search.date.to) + 54000000 : Date.parse(v.lastUpdateDate) < Date.parse(search.date.to) + 54000000)) : fromDate;
  const name = (search.customerName !== '') ? (toDate.filter((v) => v.lastName?.match(new RegExp(search.customerName.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&'))))) : toDate;
  return (search.orderId !== '') ? (name.filter((v) => v.shopOrderId.includes(search.orderId))) : name;
};
const responseToTableData = (
  kijshopCd: string,
  res: TableData[],
  checkIdArr: string[],
  machineId: string,
  orderedList: StatusData[],
  searchType: SearchType,
  options: {
    callbackClickCheck?: (id: string) => void,
    callbackClickButton?: (shopId: string, isOrdered: boolean) => void,
    // 絞り込み
    search: SearchParam,
    check?: boolean,
  },
) => orderedStatusFilter(
  res,
  orderedList,
  searchType,
  options.search,
).map((v, i) => {
  const isLaboOrderRetry = (v.status === 'ラボ発注中' && LaboOrderCompChecker.checkTimeoutForPrint(v))
  const style = v.status === 'キャンセル' ?
    { opacity: '0.3' } :
    isLaboOrderRetry ?
      { color: '#d70b24' } :
      {};
  const status = (() => {
    if (isLaboOrderRetry) return '通信エラー';
    return v.status;
  })();
  return [...[
    <Checkbox
      key={`order-list-table-check_${v.shopOrderId}_${checkIdArr.find((id) => id === v.shopOrderId)}`}
      onClick={options?.callbackClickCheck && (() => options.callbackClickCheck?.(v.shopOrderId))}
      checked={Boolean(checkIdArr.find((id) => id === v.shopOrderId))}
      styleType="1"
    />,
    // v.status || '',
    <div
      key={`order-list-table-status_${v.shopOrderId}_${v.status}`}
      className="order_status"
      data-status={v.status}
    >
      <div className="order_status__inner">
        {isLaboOrderRetry ?
          <img src={warningIcon} alt="" /> :
          <ColorIcon color={status} />
        }
        <div style={style}>
          {status}
        </div>
      </div>
    </div>,
    <div
      style={style}
      data-status={v.lastName || ''}
    >{v.lastName || ''}</div>,
    <div
      style={style}
      data-status={v.createDate || ''}
    >{v.createDate ? formatShortDate(v.createDate) : ''}</div>,
    <div
      style={style}
      data-status={v.lastUpdateDate || ''}
    >{v.lastUpdateDate ? formatShortDate(v.lastUpdateDate) : ''}</div>,
    <div
      style={{...style, fontSize: v.centerShippinDate ? '14px' : '10px'}}
      data-status={v.centerShippinDate || ''}
    >{v.centerShippinDate?.substr(2) || (
      v.orderDate
      && (!['注文作成中', '注文作成済', 'レイアウト中', 'ラボ発注可'].includes(v.status)
        || orderedList.find((o) => o.shopOrderId === v.shopOrderId))
        ? '受注メール参照' : ''
    )}
    </div>,
    <div
      style={style}
      data-status={v.shopOrderId || ''}
    >{v.shopOrderId || ''}</div>,
    <div
      style={style}
      data-status={v.prodManagNo || ''}
    >{v.prodManagNo || ''}</div>,
    // v.lastName || '',
    // v.createDate || '',
    // v.lastUpdateDate || '',
    // v.shopOrderId || '',
  ],
  <div>
    {(v.lockUser) ?
      <img
        src={padlockOnIcon}
        alt=""
      /> : <></>}
    <span
      title={v.lockUser ? v.lockUser : ''}
    >{v.lockUser}</span>
  </div>,
  <div
    style={style}
    data-status={v.orderUser || ''}
    title={v.orderUser}
  >{v.orderUser || ''}</div>,
  <Button
    label="詳細"
    icon={<img
      src={iconInfo}
      alt=""
    />}
    onClick={options?.callbackClickButton && (() => options.callbackClickButton?.(v.shopOrderId, v.status === 'ラボ発注中'))}
    size="sm"
    color="light"
  />,
  ];
});

type TableHeadKey = '' | 'check' | 'status' | 'lastName' | 'createDate' | 'updateDate' | 'shopOrderId' | 'prodManagNo' | 'centerShippinDate';
type TableHeadData = {
  key: TableHeadKey,
  label: string,
};
const tableHeadData: TableHeadData[] = [
  {
    key: 'check',
    label: '',
  },
  {
    key: 'status',
    label: 'ステータス',
  },
  {
    key: 'lastName',
    label: 'お客様名',
  },
  {
    key: 'createDate',
    label: '作成日時',
  },
  {
    key: 'updateDate',
    label: '更新日時',
  },
  {
    key: 'centerShippinDate',
    label: '出荷予定日',
  },
  {
    key: 'shopOrderId',
    label: '注文番号',
  },
  {
    key: 'prodManagNo',
    label: '生産管理番号',
  },
  {
    key: '',
    label: '操作状況',
  },
  {
    key: '',
    label: '発注者',
  },
  {
    key: '',
    label: '',
  },
];
const TableHead = (props: { label: string, sort?: 'asc' | 'desc' }) => {
  const { label, sort } = props;
  return (
    <div>
      {label}
      {sort ? (
        <>
          {sort === 'asc' ? (' ▲') : ('')}
          {sort === 'desc' ? (' ▼') : ('')}
        </>
      ) : (<></>)}
    </div>
  );
};

const mainClassName = 'print_order_table';

const BulkPrintList = () => {
  const { kijshopCd, shopOrderId } = useParams<PathParams>();
  // - Hooks -
  const dispatch = useAppDispatch();
  const { isSamePath, machineId, isProxyMode, lockId, storage } = useAppSelector((state) => ({
    isSamePath: state.newsList.isSamePath,
    machineId: state.storage.machineId,
    isProxyMode: state.systemConfig.metaData.surrogateOrder,
    lockId: state.orderLock.lockOrderId,
    storage: state.storage,
  }), lodash.isEqual);
  const lockActions = usePrintLock({ ignoreInitCheck: true });

  // - State -
  // -- 検索条件選択用 --
  const [searchType, setSearchType] = useState<SearchType>('othersOrdered');
  // -- テーブル一覧データ --
  const [tableData, setTableData] = useState<DisplayElement[][]>([]);
  const [tableViewData, setTableViewData] = useState<DisplayElement[][]>([]);
  // -- ソート --
  const [sort, setSort] = useState<'asc' | 'desc'>('desc');
  // -- ソート対象 --
  const [sortTarget, setSortTarget] = useState<TableHeadKey>('updateDate');
  // -- 注文一覧apiデータ --
  const [orderList, setOrderList] = useState<TableData[]>([]);
  const [orderedList, setOrderedList] = useState<StatusData[]>();
  // -- チェック状態管理用配列 --
  const [checkIdArr, setCheckIdArr] = useState<string[]>([]);
  // 検索用パラメータ
  const [searchParam, setSearchParam] = useState<SearchParam>({
    date: { from: '', to: '' },
    orderId: '',
    customerName: '',
    dateType: 'create',
  });
  const [checkAll, setCheckAll] = useState(false);
  // 代理発注モード　注文番号
  const [optionalNumber, setOptionalNumber] = useState('');
  // センター注文一覧
  const [centerOrderList, setCenterOrderList] = useState([])
  const changeOptionalNumberHandler = (v: string) => {
    setOptionalNumber(v);
  };

  // コピーして新規注文ボタン　disable状態管理
  const copyBtn = useCallback((): boolean => {
    const targetList = checkIdArr.map((v) => orderList.find((v2) => v2.shopOrderId === v)).filter((v) => v);
    const num = targetList.length;
    return num !== 1;
  }, [checkIdArr]);
  // -- ローディングバーパーセンテージ --
  const [progressNum, setProgressNum] = useState(0);
  // -- 通信中フラグ --
  const [connectingMessage, setConnectingMessage] = useState('');
  // - Callback -
  // -- 注文一覧画面遷移 --
  const handlerClickBackOrderList = useCallback(() => {
    dispatch(push(RoutingPath.cnv.orders({ kijshopCd })));
  }, [])
  // -- 検索条件変更 --
  const handlerClickSearchType = useCallback((v: SearchType, code: OrderStatusCode) => {
    setSearchType(v);
    setCheckAll(false);
    setCheckIdArr([]);
  }, [orderList, checkIdArr, searchParam]);
  // -- 注文詳細遷移 --
  const handlerClickOrderDetail = useCallback((shopId: string, isOrdering) => {
    dispatch(commonActions.setOrderingShopId(isOrdering ? shopId : ''));
    lockActions.check({ kijshopCd, shopOrderId: shopId }, () => {
      getData(false);
    }).then(() => {
      dispatch(printActions.getShopOrderData(kijshopCd, shopId));
      dispatch(push(RoutingPath.cnv.printOrder({ kijshopCd: kijshopCd, shopOrderId: shopId })));
    })
  }, [kijshopCd, shopOrderId, lockActions]);
  // -- 注文詳細遷移(ダブルクリック) --
  const handlerDoubleClickItem = useCallback((i, v) => {
    // -- ソートで不整合が起きそうなのでテーブルのデータみちゃう --
    if ((v[5] as JSX.Element).props?.['data-status'] || (v[5] && typeof v[5] === 'string')) {
      handlerClickOrderDetail((v[5] as JSX.Element).props?.['data-status'] || v[5], false);
    }
  }, [handlerClickOrderDetail]);
  // -- チェックボックス --
  const handlerClickCheckbox = useCallback((id: string) => {
    const statusCode = searchButtonList.find((v) => v.type === searchType)?.code;
    setCheckIdArr((prev) => {
      const arr = [...prev];
      const index = arr.findIndex((v) => v === id);
      if (index !== -1) {
        arr.splice(index, 1);
      } else {
        arr.push(id);
      }
      setTableData(responseToTableData(
        kijshopCd,
        orderList,
        arr,
        machineId,
        orderedList || [],
        searchType,
        {
          callbackClickCheck: handlerClickCheckbox,
          search: searchParam,
        },
      ));
      return arr;
    });
  }, [orderList, checkIdArr, searchType, searchParam]);
  // -- 詳細検索 --
  const handlerClickDetailSearch = useCallback(() => {
    const statusCode = searchButtonList.find((v) => v.type === searchType)?.code;
    dispatch(dialogActions.push({
      title: '詳細検索',
      element:
        <DetailSearch
          handlerClickSearch={(value) => {
            setSearchParam(value);
            setCheckAll(false);
            setCheckIdArr([]);
            dispatch(dialogActions.pop());
          }}
          handlerClickClose={() => dispatch(dialogActions.pop())}
          searchParam={searchParam}
        />,
    }));
  }, [searchParam, checkIdArr, handlerClickCheckbox, handlerClickOrderDetail]);
  // -- 新規注文作成 --
  const createOrder = useCallback(() => {
    const showErrorMsg = () => {
      setConnectingMessage('')
      dispatch(dialogActions.pushMessage({
        title: 'エラー',
        message: ['注文の作成に失敗しました'],
        buttons: [{
          label: 'OK',
          callback: () => {
            dispatch(dialogActions.pop());
          },
        }],
      }));
    }
    setConnectingMessage('データを作成中です...');
    // dispatch(printActions.shopOrder({ kijshopCd, shopOrderId: 'dummy' }).create({ success: () => {}, error: () => {} }))
    dispatch(apiActions.run(
      new ApiNumberingOrder({}),
      {
        onSuccess: (res: ResponseBase<NumberingOrderResponse>) => {
          const orderNo = (isProxyMode) ? optionalNumber : res.body.data?.orderNo;
          if (orderNo) {
            dispatch(printActions.shopOrder({ kijshopCd, shopOrderId: orderNo }).create(
              !!isProxyMode,
              {
                success: () => {
                  dispatch(apiActions.run(new ApiPrintMetaShopOrderPost(
                    {
                      kijshopCd,
                      shopOrderId: orderNo,
                      lastUpdateDate: DateFormatter.date2str(new Date(), 'YYYYMMDD_HHmmSS', '/'),
                      createDate: DateFormatter.date2str(new Date(), 'YYYYMMDD_HHmmSS', '/'),
                      lastName: '',
                      note: '',
                      orderDate: '',
                      status: '注文作成中',
                      orderCompleteDate: '',
                      orderUser: '',
                    },
                  ),
                    {
                      onSuccess: () => {
                        dispatch(push(RoutingPath.cnv.printOrder({ kijshopCd: kijshopCd, shopOrderId: orderNo })));
                        setConnectingMessage('');
                      },
                      onError: () => showErrorMsg(),
                    },
                    { ignoreSystemError: true },
                  ));
                },
                error: () => showErrorMsg(),
              },
            ));
          } else {
            showErrorMsg()
          }
        },
        onError: () => showErrorMsg(),
      },
    ));
  }, [dispatch, kijshopCd, optionalNumber, isProxyMode]);

  const handlerClickCreateOrder = useCallback(() => {
    if (isProxyMode) {
      if (optionalNumber.length !== 13) {
        dispatch(dialogActions.pushMessage({
          title: '確認',
          message: ['発注番号は、13桁の番号を入力してください。'],
          buttons: [{
            label: 'OK',
            callback: () => dispatch(dialogActions.pop()),
          }],
        }));
        return;
      }
      const check = optionalNumber.match(/[^0-9]+/);
      if (check?.length) {
        dispatch(dialogActions.pushMessage({
          title: '確認',
          message: ['発注番号に、不正な文字が入力されています。', '', optionalNumber],
          buttons: [{
            label: 'OK',
            callback: () => {
              dispatch(dialogActions.pop());
              setOptionalNumber(optionalNumber.replace(check[0], ''));
            },
          }],
        }));
        return;
      }
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: ['下記の注文番号で新規作成してよろしいですか？', '', optionalNumber],
        buttons: [
          {
            label: 'キャンセル',
            callback: () => {
              dispatch(dialogActions.pop());
              return;
            },
          },
          {
            label: 'OK',
            callback: () => {
              dispatch(dialogActions.pop());
              setConnectingMessage('発注番号を確認中です...');
              dispatch(apiActions.run(
                new ApiShopOrderListGet(
                  kijshopCd,
                ),
                {
                  onSuccess: (data: ResponseBase<ShopOrderListGetResponseStatus>) => {
                    if (data.body.data) {
                      const check = Boolean(data.body.data.statusList.find((v) => v.shopOrderId === optionalNumber));
                      setConnectingMessage('');
                      if (check) {
                        dispatch(dialogActions.pushMessage({
                          title: '確認',
                          message: [
                            'すでに同じ番号が存在しているため,',
                            'この番号は使用できません。',
                          ],
                          buttons: [{
                            label: 'OK',
                            callback: () => dispatch(dialogActions.pop()),
                          }],
                        }));
                        return;
                      }
                      createOrder();
                    }
                  },
                  onError: () => setConnectingMessage(''),
                },
              ));
            },
          },
        ],
      }));
    } else {
      createOrder();
    }
  }, [optionalNumber, createOrder]);

  // -- コピーして注文作成 --
  const handlerClickCopyOrder = useCallback(() => {
    const copyOrderNumList = checkIdArr[0];
    const message = [
      '下記の注文番号の注文データをコピーします。',
      'よろしいですか？',
      '',
      copyOrderNumList,
    ];
    dispatch(dialogActions.pushMessage({
      title: '確認',
      message,
      buttons: [
        {
          label: 'いいえ',
          callback: () => {
            dispatch(dialogActions.pop());
          },
        },
        {
          label: 'はい',
          callback: () => {
            dispatch(dialogActions.pop());
            setConnectingMessage('データをコピー中です...');
            const copyId = checkIdArr[0];
            let newId = '';
            const copy = new Promise<void>((resolve, reject) => {
              if (checkIdArr.length >= 2 || !checkIdArr) reject();
              dispatch(apiActions.run(
                new ApiPrintMetaShopOrderGet({
                  kijshopCd: kijshopCd,
                  shopOrderId: copyId,
                }),
                {
                  onSuccess: (res: ResponseBase<MetaPrintShopOrderGetResponse>) => {
                    dispatch(apiActions.run(
                      new ApiNumberingOrder({}),
                      {
                        onSuccess: (resId: ResponseBase<NumberingOrderResponse>) => {
                          const orderNo = resId.body.data?.orderNo;
                          if (orderNo && res.body.data) {
                            newId = orderNo;
                            const data = {
                              shopOrderId: orderNo,
                              lastUpdateDate: DateFormatter.date2str(new Date(Date.now()), 'YYYYMMDD_HHmmSS'),
                              createDate: DateFormatter.date2str(new Date(Date.now()), 'YYYYMMDD_HHmmSS'),
                              lastName: res.body.data.lastName,
                              note: res.body.data.note,
                              status: (!['注文作成中', '注文作成済', 'レイアウト中'].includes(res.body.data.status)) ? 'ラボ発注可' : res.body.data.status,
                            };
                            dispatch(apiActions.run(
                              new ApiPrintShopOrderCopy(
                                {
                                  kijshopCd: kijshopCd,
                                  shopOrderId: copyId,
                                  copyShopOrderId: orderNo,
                                  data: data,
                                },
                              ),
                              {
                                onSuccess: () => resolve(),
                                onError: () => reject(),
                              },
                              { ignoreSystemError: true },
                            ));
                          } else {
                            reject();
                          }
                        },
                        onError: () => reject(),
                      },
                      { ignoreSystemError: true },
                    ));
                  },
                  onError: () => reject(),
                },
                { ignoreSystemError: true },
              ));
            });
            copy.then(() => {
              setConnectingMessage('');
              dispatch(dialogActions.pushMessage({
                title: '確認',
                message: ['下記の注文番号でコピーが作成されました。', '', newId],
                buttons: [
                  {
                    label: 'OK',
                    callback: () => {
                      dispatch(dialogActions.pop());
                      handlerClickOrderDetail(newId, false);
                    },
                  },
                ],
              }));
            }).catch(() => {
              setConnectingMessage('');
              dispatch(dialogActions.pushMessage({
                title: 'エラー',
                message: ['注文の作成に失敗しました'],
                buttons: [{
                  label: 'OK',
                  callback: () => {
                    dispatch(dialogActions.pop());
                  },
                }],
              }));
            });
          },
        },
      ],
    }));
  }, [checkIdArr, orderList, orderedList]);
  // -- まとめてラボ発注 --
  const handlerClickOrderSome = useCallback(() => {
    dispatch(dialogActions.push({
      title: 'ラボ発注',
      element: <LabOrderForPrint
        kijshopCd={kijshopCd}
        orderList={[...checkIdArr].map((id) => {
          const data = orderList.find((v) => v.shopOrderId === id);
          return {
            createDate: data?.createDate || '',
            lastName: data?.lastName || '',
            shopOrderId: data?.shopOrderId || id,
            status: data?.status || '',
          };
        })}
        callbackEndOrder={() => getData(false)}
      />,
    }));
  }, [checkIdArr, orderList, kijshopCd]);
  // -- 一覧データ取得 --
  const getData = useCallback((init: boolean) => {
    setConnectingMessage('データを読み込み中です...');
    setCheckIdArr([]);
    const getList = (staffList: StaffNameEntity[]) => {
      dispatch(apiActions.run(
        new ApiPrintShopOrderStatusListGet(kijshopCd),
        {
          onSuccess: (res: ResponseBase<PrintStatusList>) => {

            dispatch(apiActions.run(
              new ApiOrders({}),
              {
                onSuccess: async (orderedRes: ResponseBase<OrdersResponse>) => {
                  const list = orderedRes.body.data?.order || [];
                  if (list.length) {
                    dispatch(commonActions.setOrderedList({ order: [...list] }));
                  }
                  setOrderedList(list);
                  const arr: TableData[] = [...res.body.data || []].map((v) => {
                    let staff
                    if (staffList) {
                      staff = staffList.find((data) => data.staffId === v.lockUser);
                    } else {
                      staff = null
                    }
                    const lockUser = staff ? staff.name : v.lockUser;
                    if (v.lockUser === machineId) {
                      dispatch(printOrderLockActions.unlock(kijshopCd, v.shopOrderId));
                    }
                    const orderData = list.find((data) => data.shopOrderId === v.shopOrderId);
                    return ({
                      createDate: v.createDate,
                      lastName: v.lastName,
                      lastUpdateDate: v.lastUpdateDate,
                      lockUser: (v.lockUser === machineId) ? '' : lockUser,
                      note: v.note,
                      orderDate: v.orderDate,
                      shopOrderId: v.shopOrderId,
                      status: orderData?.orderStatusName || v.status,
                      orderCompleteDate: v.orderCompleteDate,
                      orderUser: v.orderUser,
                      prodManagNo: orderData?.prodManagNo ?? '',
                      centerShippinDate: v.centerShippinDate,
                    });
                  });
                  setOrderList(arr);
                  setConnectingMessage('');
                },
                onError: () => {
                  const arr: TableData[] = [...res.body.data || []].map((v) => ({
                    createDate: v.createDate,
                    lastName: v.lastName,
                    lastUpdateDate: v.lastUpdateDate,
                    lockUser: v.lockUser,
                    note: v.note,
                    orderDate: v.orderDate,
                    shopOrderId: v.shopOrderId,
                    status: v.status,
                    orderCompleteDate: v.orderCompleteDate,
                    orderUser: v.orderUser,
                    prodManagNo: '',
                    centerShippinDate: v.centerShippinDate,
                }));
                  setOrderList(arr);
                  setConnectingMessage('');
                },
              },
              { ignoreSystemError: true },
            ));
          },
          onError: () => {
            setConnectingMessage('');
          },
        },
        { ignoreSystemError: true },
      ));
    }
    dispatch(apiActions.run(
      new ApiGetStaffNameList({ kijshopCd }), {
      onSuccess: (res: ResponseBase<GetStaffNameResponse>) => {
        if (res.body.data) {
          getList(res.body.data.staffNameList);
        } else {
          getList([]);
        }
      },
      onError: () => {
        getList([]);
      }
    }
    ));
  }, [kijshopCd, machineId]);
  // -- 削除 --
  const handlerClickDelete = useCallback(() => {
    dispatch(dialogActions.pushMessage({
      title: '確認',
      message: ['選択した注文情報を削除します。よろしいですか？'],
      buttons: [
        {
          label: 'いいえ',
          callback: () => {
            dispatch(dialogActions.pop());
          },
        },
        {
          label: 'はい',
          callback: () => {
            dispatch(dialogActions.pop());
            setConnectingMessage('注文を削除しています...');
            let lockList: { shopOrderId: string, lockUser: string }[] = [];
            let unlockList: string[] = [];
            Promise.all(checkIdArr.map((v) =>
              new Promise<void>((resolve) => {
                dispatch(apiActions.run(
                  new ApiPrintOrderLockCheck({ kijshopCd, shopOrderId: v }),
                  {
                    onSuccess: (res: ResponseBase<OrderLockCheckResponse>) => {
                      const data = res.body.data;
                      if (data && data.name !== null) {
                        lockList.push({ shopOrderId: v, lockUser: data.name });
                      } else {
                        unlockList.push(v);
                      }
                      resolve();
                    },
                  },
                  { ignoreSystemError: true },
                ));
              }),
            )).then(() => {
              dispatch(apiActions.runAll(
                [...[...unlockList].map((id) => new ApiPrintShopOrderDataDelete({ kijshopCd, shopOrderId: id }))],
                {
                  onSuccess: () => {
                    setConnectingMessage('');
                    if (lockList.length) {
                      dispatch(dialogActions.pushMessage({
                        title: '確認',
                        message: [
                          '下記の注文は現在編集中のため、削除できませんでした。', '',
                          ...lockList.map((v) => `・ ${v.shopOrderId}（${v.lockUser}）`),
                        ],
                        buttons: [{
                          label: 'OK',
                          callback: () => {
                            dispatch(dialogActions.pop());
                            setCheckIdArr([]);
                            getData(false);
                          },
                        }],
                      }));
                    } else {
                      setCheckIdArr([]);
                      getData(false);
                    }
                  },
                  onError: () => {
                    setConnectingMessage('');
                    dispatch(dialogActions.pop());
                    dispatch(dialogActions.pushMessage({
                      title: 'エラー',
                      message: ['注文の削除に失敗しました'],
                      buttons: [{
                        label: 'OK',
                        callback: () => {
                          dispatch(dialogActions.pop());
                        },
                      }],
                    }));
                  },
                },
                true,
              ));
            }).catch(() => {
            });
          },
        },
      ],
    }));
  }, [checkIdArr, orderList, kijshopCd, orderedList, getData]);

  const handlerClickTableColumn = useCallback((index) => {
    const data = tableHeadData[index];
    if (data?.key && data.key !== 'check') {
      if (data.key === sortTarget) {
        setSort(sort === 'asc' ? 'desc' : 'asc');
      } else {
        setSort('desc');
        setSortTarget(data.key);
      }
    }
  }, [tableHeadData, sort, sortTarget]);
  // -- 全チェック --
  const handlerClickCheckAll = useCallback((flag) => {
    // setCheckIdArr(v ? [...orderList].map((order) => order.shopOrderId) : []);
    setCheckAll(flag);
    if (!flag) {
      setCheckIdArr([]);
      return;
    }
    const arr: string[] = [];
    tableViewData.forEach((v) => {
      const id = (v[5] as JSX.Element).props?.['data-status'] || v[5];
      if (id && typeof id === 'string') {
        arr.push(id);
      }
    });
    setCheckIdArr(arr);
    // setCheckIdArr(flag ? [...tableViewData].map((order) => (order[5] as JSX.Element)?.props?.['data-status'] || (v[5] && typeof v[5] === 'string')) : []);
  }, [tableViewData]);
  useEffect(() => {
    if (lockId !== '') {
      dispatch(printOrderLockActions.unlock(kijshopCd, lockId));
      dispatch(printOrderLockActions.setId(''));
    }
  }, [lockId]);
  // -- 一覧データ取得(旧) --
  useEffect(() => {
    // TODO 先の画面のデータリセット
    dispatch(orderPreparationActions.setOrderList([], kijshopCd));
    dispatch(commonActions.setCustomerName(''));
    if (isSamePath) {
      dispatch(newsListActions.setIsSamePath(false));
    }
  }, [kijshopCd, isSamePath]);
  // -- 画面表示更新 --
  useEffect(() => {
    const data = responseToTableData(
      kijshopCd,
      orderList,
      checkIdArr,
      machineId,
      orderedList || [],
      searchType,
      {
        callbackClickCheck: handlerClickCheckbox,
        callbackClickButton: handlerClickOrderDetail,
        search: searchParam,
      },
    );
    setTableData(data);
    setTableViewData(data);
  }, [orderList, searchParam, orderedList, searchType, checkAll]);
  // -- ソート --
  useEffect(() => {
    const index = () => {
      switch (sortTarget) {
        case 'status':
          return 1;
        case 'lastName':
          return 2;
        case 'createDate':
          return 3;
        case 'updateDate':
          return 4;
        case 'shopOrderId':
          return 5;
        default:
          return 5;
      }
    };
    const data = [...tableData].sort((a, b) => {
      const int = index();
      // const v1 = int === 1 ? ((a[int] as JSX.Element).props?.['data-status'] || a[int]) : a[int];
      // const v2 = int === 1 ? ((b[int] as JSX.Element).props?.['data-status'] || b[int]) : b[int];
      const v1 = (a[int] as JSX.Element).props?.['data-status'];
      const v2 = (b[int] as JSX.Element).props?.['data-status'];
      if (sort === 'desc') {
        if (v1 < v2) {
          return 1;
        } else {
          return -1;
        }
      } else {
        if (v1 > v2) {
          return 1;
        } else {
          return -1;
        }
      }
    });
    setTableViewData(data);
  }, [tableData, sort, sortTarget]);
  useEffect(() => {
    console.log('pathtest', document.referrer);
    getData(true);
    if (storage.kijshopCd !== kijshopCd || storage.kijshopCd === '') {
      dispatch(localStorageActions.getLocalData(kijshopCd));
    }
  }, []);

  const tableHead = [...tableHeadData].map((v) => (
    v.key === 'check' ? (
      <Checkbox
        checked={checkAll}
        onClick={() => handlerClickCheckAll(!checkAll)}
      />
    ) : (
      <TableHead
        label={v.label}
        sort={(v.key && sortTarget === v.key) ? sort : undefined}
      />
    )
  ));

  /* デバッグ用XML取得 TODO 消す */
  // useEffect(() => {
  //   if (!(window as any).xml) {
  //     (window as any).xml = (id: string) => {
  //       new ApiAllGetXml(kijshopCd, id)
  //         .do()
  //         .then((res) => {
  //           const files = ((res as ResponseBase<GetXmlResponse>)?.body?.data as GetXmlResponse).fileinfo;
  //           if (!files?.length) {
  //             console.error('ファイルの取得に失敗しました');
  //             console.log(res.message);
  //             return;
  //           }
  //           const zip = new JSZip();
  //           files.forEach((v) => zip.file(v.filename, v.body));
  //           zip
  //             .generateAsync({ type: 'blob' })
  //             .then((content) => {
  //               const url = (window.URL || window.webkitURL).createObjectURL(content);
  //               const a = document.createElement('a');
  //               a.href = url;
  //               a.download = `${id}.zip`;
  //               a.click();
  //               (window.URL || window.webkitURL).revokeObjectURL(url);
  //             });
  //         })
  //         .catch((e) => {
  //           console.error('ファイルの取得に失敗しました');
  //           console.log(e);
  //         });
  //     };
  //   }
  // }, []);

  useEffect(() => {
    dispatch(apiActions.run(
      new ApiPrintShopOrderStatusListGet(kijshopCd),
      {
        onSuccess: (res) => {}
      }
    ))
  }, []);
  return (
    <div className="page_base">
      <Header page={'order'} />
      <div className='list_page_contents'>
        <div className={mainClassName}>
          <div className={`${mainClassName}__type_select`}>
            <div>
              {searchButtonList.map((v, i) => (
                <SelectButton
                  key={`order-list-search-type_${i}`}
                  type={v.type}
                  currentType={searchType}
                  label={v.label}
                  callback={() => handlerClickSearchType(v.type, v.code)}
                />
              ))}
              <Button
                label="詳細の検索"
                onClick={handlerClickDetailSearch}
                icon={<i className="fas fa-search" />}
                className="search_detail"
              />
            </div>
          </div>
          <div className={`${mainClassName}__menu_btn`}>
            {isProxyMode ? (
              <div className="proxy_mode_form">
                <div className="proxy_mode_form__label">
                  <div>代理発注モード</div>
                  <div>発注番号を入力して新規作成</div>
                </div>
                <Input
                  value={optionalNumber}
                  onChange={(e) => changeOptionalNumberHandler(e.target.value)}
                />
              </div>
            ) : (<></>)}
            <Button
              label="新規作成"
              onClick={handlerClickCreateOrder}
              icon={<i className="fas fa-plus" />}
              color="warning"
            />
            {!isProxyMode ? (
              <Button
                label="コピーして新規注文"
                onClick={handlerClickCopyOrder}
                color="light"
                disabled={copyBtn()}
              />
            ) : (<></>)}
            <Button
              label="一括送信（発注）"
              onClick={handlerClickOrderSome}
              color="light"
              disabled={!checkIdArr.length}
            />
            <Button
              label="通常注文一覧へ"
              onClick={handlerClickBackOrderList}
              color="blue_primary"
              icon={<img alt="" src={iconChangeTable} />}
              iconPosition='right'
            />
            <Button
              label="削除"
              onClick={handlerClickDelete}
              icon={<img
                src={iconDelete}
                alt=""
              />}
              color="light"
              disabled={
                !checkIdArr.length
                || Boolean(checkIdArr.find((v) =>
                  orderList.find((data) => data.shopOrderId === v)?.status === 'ラボ発注中'
                  || orderedList?.find((data) => data.shopOrderId === v),
                ))
              }
            />
          </div>
          <div className={`${mainClassName}__table`}>
            <Table
              head={tableHead}
              body={tableViewData}
              minimumNumOfRows={10}
              handlerClickColumn={handlerClickTableColumn}
              handlerDblClick={(index, v) => handlerDoubleClickItem(index, v)}
              theme="print"
            />
          </div>
          <LoadingBar
            message="注文データをコピーしています"
            progressNum={progressNum}
          />
          {connectingMessage ? (<LoadingPopup label={connectingMessage} />) : (<></>)}
        </div>
      </div>
    </div>
  );
};

export default BulkPrintList;
